import ptBrTranslations from './pt-BR'
import esCLTranslations from './es-CL'
import esCOTranslations from './es-CO'
import esMXTranslations from './es-MX'
import esPETranslations from './es-PE'
import esPATranslations from './es-PA'
import esCRTranslations from './es-CR'

export default {
  'pt-BR': ptBrTranslations,
  'es-CL': esCLTranslations,
  'es-CO': esCOTranslations,
  'es-MX': esMXTranslations,
  'es-PE': esPETranslations,
  'es-PA': esPATranslations,
  'es-CR': esCRTranslations,
}
